import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { AuthenticationService } from "../../services/authentication/authentication.service";
import { Role } from "../../models/roles";

@Component({
  selector: "app-login",
  templateUrl: "login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error = "";

  showOverlay = true;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService
  ) {
    // redirect to home if already logged in
    if (this.authenticationService.currentUserValue) {
      const user = this.authenticationService.currentUserValue;
      if (user.role === Role.Admin) {
        this.router.navigate(["/admin"]);
      } else if (user.role === Role.Editor) {
        this.router.navigate(["/editor"]);
      } else if (user.role === Role.Psychologist) {
        this.router.navigate(["/psychologist"]);
      } else if (user.role === Role.CRM) {
        this.router.navigate(["/crm"]);
      } else if (user.role === Role.User) {
        this.router.navigate(["/user"]);
      } else {
        this.showOverlay = false;
      }
    } else {
      this.showOverlay = false;
    }
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ["", Validators.required],
      password: ["", Validators.required],
    });

    this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/user";
  }

  get f() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;
    this.authenticationService
      .login(this.f.username.value, this.f.password.value)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data["role"] === "Admin") {
            return this.router.navigateByUrl("/admin");
          } else if (data["role"] === "User") {
            return this.router.navigateByUrl("/user");
          } else if (data["role"] === "CRM") {
            return this.router.navigateByUrl("/crm");
          }
          // window.history.pushState({}, "", this.returnUrl);
          this.router.navigateByUrl(this.returnUrl || "/");

          // this.router.navigateByUrl("/", {
          //   skipLocationChange: true,
          //   state: {},
          // });
        },
        (error) => {
          this.error = error.error["message"];
          this.loading = false;
        }
      );
  }
}
